const projects = [
  {
    id: 0,
    companyLogo:
      'https://res.cloudinary.com/poolzmooth/image/upload/v1608436917/Portfolio/emurgo-logo.svg',
    projectName: 'Intoom',
    date: 'August 2020',
    duration: '~ 6 months',
    tags: ['software development', 'education'],
    description:
      'Intoom is an interactive distribution marketplace where distributors and users can talk face-to-face with each other using online tools with learning purposes.',
    company: 'Emurgo',
    position: 'Front End Software Engineer',
    thumbnail:
      'https://res.cloudinary.com/poolzmooth/image/upload/v1608436927/Portfolio/intoom-thumbnail.png',
    link: 'https://intoom-stg.herokuapp.com/',
  },
  {
    id: 1,
    companyLogo:
      'https://res.cloudinary.com/poolzmooth/image/upload/v1608436917/Portfolio/emurgo-logo.svg',
    projectName: 'Emurgo Traceability',
    date: 'February 2020',
    duration: '~ 6 months ',
    tags: ['supply chain', 'blockchain'],
    description:
      'Developed supply chain traceability software which fully leverages the unique qualities of blockchain for enterprises. Such as Blue Korintji, Canndescent, Nescafe, and more.  ',
    company: 'Emurgo',
    position: 'Front End Software Engineer',
    thumbnail:
      'https://res.cloudinary.com/poolzmooth/image/upload/v1608437348/Portfolio/emurgo-thumbnail.png',
    link: 'https://emurgo.io/our-products#emurgo-traceability',
  },
  {
    id: 2,
    companyLogo:
      'https://res.cloudinary.com/poolzmooth/image/upload/v1608436917/Portfolio/yoroi-logo.svg',
    projectName: 'Yoroi Extension',
    date: 'March 2020',
    duration: 'Maintain',
    tags: ['cryptocurrency', 'blockchain'],
    description:
      'A simple, secure and fast Cardano ADA wallet. It is a lightweight wallet that launches quicklysending.',
    company: 'Emurgo',
    position: 'Front End Software Engineer',
    thumbnail:
      'https://res.cloudinary.com/poolzmooth/image/upload/v1608437633/Portfolio/yoroi-thumbnail.png',
    link: 'https://yoroi-wallet.com/#/',
  },
  {
    id: 3,
    companyLogo:
      'https://res.cloudinary.com/poolzmooth/image/upload/v1608436917/Portfolio/emurgo-logo.svg',
    projectName: 'Emurgo.io',
    date: 'June 2020',
    duration: '~1 month',
    tags: ['blockchain', 'startups', 'enterprise'],
    description:
      'EMURGO is a multinational blockchain technology company providing solutions for developers, startups, enterprises, and governments',
    company: 'Emurgo',
    position: 'Front End Software Engineer',
    thumbnail:
      'https://res.cloudinary.com/poolzmooth/image/upload/v1608438002/Portfolio/emurgoio-thumbnail.png',
    link: 'https://emurgo.io/',
  },
  {
    id: 4,
    companyLogo:
      'https://res.cloudinary.com/poolzmooth/image/upload/v1608436916/Portfolio/logo_brandmark.svg',
    projectName: 'Brandmark.',
    date: 'October 2020',
    duration: '~1 month',
    tags: ['supply chain transparency', 'blockchain technology'],
    description: 'Supply Chain solutions using Blockchain technology',
    company: 'Emurgo',
    position: 'Front End Software Engineer',
    thumbnail:
      'https://res.cloudinary.com/poolzmooth/image/upload/v1608438036/Portfolio/brandmark-thumbnail.png',
    link: 'https://www.brandmarktrace.com/',
  },
  {
    id: 5,
    companyLogo:
      'https://res.cloudinary.com/poolzmooth/image/upload/c_thumb,w_200,g_face/v1608438953/Portfolio/default-logo.png',
    projectName: 'Disnovo Lab',
    date: 'April 2019',
    duration: '7 months',
    tags: ['UI UX Design', 'software development', 'CMR'],
    company: 'Personal',
    description:
      'A content management system that helps users create, manage, and modify content on a website without the need for specialized technical knowledge.',
    position: 'UI UX Designer & Front End Developer ',
    thumbnail:
      'https://res.cloudinary.com/poolzmooth/image/upload/v1608439235/Portfolio/disnovo-thumbnail.png',
    link: 'https://disnovolab.com/EN/index.html',
  },
  {
    id: 6,
    companyLogo:
      'https://res.cloudinary.com/poolzmooth/image/upload/v1608441203/Portfolio/panda-logo.png',
    projectName: 'Panda CMS',
    date: 'April 2019',
    duration: '7 months',
    tags: ['CMS'],
    company: 'Personal',
    description:
      'A content management system that helps users create, manage, and modify content on a website without the need for specialized technical knowledge.',
    position: 'Front End Developer',
    thumbnail:
      'https://res.cloudinary.com/poolzmooth/image/upload/v1608440999/Portfolio/pandacms-thumbnail.png',
    link: 'https://www.youtube.com/watch?v=M0hhMVTpbVE&ab_channel=AbnerPa%C3%BAlCcariLindo',
  },
  {
    id: 7,
    companyLogo:
      'https://res.cloudinary.com/poolzmooth/image/upload/c_thumb,w_200,g_face/v1608438953/Portfolio/default-logo.png',
    projectName: 'Petgram',
    date: 'Julio 2019',
    duration: '~ 1 month',
    tags: ['social network'],
    company: 'Personal',
    description: 'A Clone of Instagram for pets using Graphql, React, Webpack, Styled Components',
    position: 'Front End Developer',
    thumbnail:
      'https://res.cloudinary.com/poolzmooth/image/upload/v1608441600/Portfolio/petgram-thumbnail.png',
    link: 'https://mypetgram-paulccari.netlify.com/',
  },
];
export { projects };
